
import { SubDomain } from "../SubDomain.js";
import Label from "./Label.js";
import LabelOperations from "./LabelOperations.js";
import StringUtils from "../../../utils/StringUtils.js";
import LabelMap from "./LabelMap.js";

export default class LabelsDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, Label.MODEL_NAME);
    this._storage = storage.LabelStorage;
  }

  list() {
    return this._storage.list;
  }

  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Label(this.domain, item);
      }
    }

    let label = new Label(this.domain);
    if (StringUtils.isNotEmpty(objId)) {
      label.withId(objId);
    }
    return label;
  }

  findByCompany(company) {
    var labelMap = new LabelMap(this.domain);
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      const label = new Label(this.domain, item);
      if (label.company().idEquals(company)) {
        labelMap.add(label);
      }
    }

    return labelMap;
  }

  operations() {
    return new LabelOperations(this.domain.events());
  }
}